import Report, { FGeneralSettings } from '../../../common/types/api/report'

const setGeneralSettings = (newProps: FGeneralSettings, report: Report): Report => {
    return {
        ...report,
        title: newProps.title,
        enabled: newProps.enabled,
        description: newProps.description
    }
}
const getGeneralSettings = (report: Report): FGeneralSettings => {
    return {
        enabled: report.enabled,
        title: report.title,
        description: report.description
    }
}
export { getGeneralSettings, setGeneralSettings }
